import React from 'react'
import { Outlet } from 'react-router-dom'
import SimpleLayout from '../layouts/SimpleLayout'

const PublicRoutes = () => (
	<SimpleLayout>
		<Outlet />
	</SimpleLayout>
)

export default PublicRoutes
